import React from 'react';
import './Loader.scss';
import { Spin } from 'antd';

export default function Loader() {
  return (
    <div className="Loader">
      <Spin />
    </div>
  );
}
